(function(){
if(window.MBFav)return;
var KEY='mb_favorites_v1';
var HEART='M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z';
var reduced=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
var ROOT=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
var FAV_URL=ROOT+'pages/favorites';
var DQ=String.fromCharCode(34),SQ=String.fromCharCode(39);
var cache={};
var pageRender=null;
function svg(c){return `<svg class='mbf-heart ${c||''}' viewBox='0 0 24 24' aria-hidden='true'><path d='${HEART}'/></svg>`}
function esc(s){return String(s==null?'':s).split('&').join('&amp;').split('<').join('&lt;').split('>').join('&gt;').split(DQ).join('&quot;').split(SQ).join('&#39;')}
function read(){try{var a=JSON.parse(localStorage.getItem(KEY)||'[]');return Array.isArray(a)?a:[]}catch(e){return []}}
function write(a){try{localStorage.setItem(KEY,JSON.stringify(a))}catch(e){}}
function has(h){return read().indexOf(h)>-1}
function fire(h,added){document.dispatchEvent(new CustomEvent('mbfav:change',{detail:{handle:h,added:added}}))}
function toggle(h){var a=read(),i=a.indexOf(h),added=i<0;if(added)a.unshift(h);else a.splice(i,1);write(a);fire(h,added);return added}
function remove(h){var a=read(),i=a.indexOf(h);if(i>-1){a.splice(i,1);write(a);fire(h,false)}}
function clearAll(){write([]);fire(null,false)}
window.MBFav={get:read,has:has,toggle:toggle,remove:remove};
function onFavPage(){return !!document.getElementById('MBFavPage')}
function pop(el){el.classList.remove('is-pop');void el.offsetWidth;el.classList.add('is-pop');setTimeout(function(){el.classList.remove('is-pop')},750)}
function config(){
var el=document.getElementById('MBFConfig'),d=el?el.dataset:{};
function b(v,def){return v===undefined?def:v==='true'}
return {card:b(d.card,true),pdp:b(d.pdp,true),transition:b(d.transition,true),auto:b(d.auto,true),size:parseFloat(d.size)||24,pdpStyle:d.pdpStyle||'icon',pdpLabel:d.pdpLabel||'Add to favorites',pdpLabelOn:d.pdpLabelOn||'Saved'};
}

var toastEl,toastT;
function toast(msg){
if(!toastEl){toastEl=document.createElement('div');toastEl.className='mbf-toast';toastEl.setAttribute('role','status');document.body.appendChild(toastEl)}
toastEl.innerHTML=svg()+'<span>'+esc(msg)+'</span>';
toastEl.classList.add('is-show');
clearTimeout(toastT);toastT=setTimeout(function(){toastEl.classList.remove('is-show')},1800);
}

function burst(dir){
var b=document.createElement('div');
b.className='mbf-burst is-'+dir;
var p='';
for(var i=0;i<10;i++){var ang=i/10*Math.PI*2,r=120+Math.random()*100;p+=`<span class='mbf-burst__p' style='--dx:${Math.round(Math.cos(ang)*r)}px;--dy:${Math.round(Math.sin(ang)*r)}px;--d:${(i%5)*40}ms'>${svg()}</span>`}
b.innerHTML=`<div class='mbf-burst__heart'>${svg()}</div>${p}`;
document.body.appendChild(b);
if(dir==='out')setTimeout(function(){b.remove()},1200);
return b;
}

function sparkle(el){
if(reduced)return;
var r=el.getBoundingClientRect();
for(var i=0;i<6;i++){
var s=document.createElement('span');s.className='mbf-spark';
var ang=(i/6)*Math.PI*2;
s.style.cssText=`left:${r.left+r.width/2}px;top:${r.top+r.height/2}px;--dx:${Math.round(Math.cos(ang)*36)}px;--dy:${Math.round(Math.sin(ang)*36)}px`;
s.innerHTML=svg();
document.body.appendChild(s);
setTimeout(function(n){n.remove()},800,s);
}
}

function updateHeader(){
var n=read().length;
document.querySelectorAll('.header__icon--fav').forEach(function(a){
a.classList.toggle('has-items',n>0);
var c=a.querySelector('.mbf-count');
if(c){c.hidden=n===0;var s=c.querySelector('span');if(s)s.textContent=n>99?'99+':String(n)}
});
}
function measureHeader(){
var a=document.querySelector('.header__icon--fav');if(!a)return;
var cfg=config(),S=0;
if(cfg.auto){
var acc=document.querySelector('.header__icon--account svg'),cart=document.querySelector('.header__icon--cart svg');
var r=acc?acc.getBoundingClientRect():null;
if(r&&r.height>0){S=r.height*1.24}
else{r=cart?cart.getBoundingClientRect():null;if(r&&r.height>0)S=r.height*0.74}
}else{S=cfg.size}
if(S>0)a.style.setProperty('--mbf-hs',Math.round(Math.max(16,Math.min(S,44)))+'px');
}
function onHeaderClick(e){
if(e.metaKey||e.ctrlKey||e.shiftKey||e.altKey||e.button>0)return;
e.preventDefault();
var a=e.currentTarget;
pop(a);
if(onFavPage())return;
if(reduced||!config().transition){setTimeout(function(){location.href=FAV_URL},reduced?0:350);return}
try{sessionStorage.setItem('mbfav_nav','1')}catch(x){}
burst('in');
setTimeout(function(){location.href=FAV_URL},640);
}
function mountHeader(){
var icons=document.querySelector('.header__icons');
if(!icons||icons.querySelector('.header__icon--fav'))return;
var a=document.createElement('a');
a.href=FAV_URL;
a.className='header__icon header__icon--fav link focus-inset';
a.setAttribute('aria-label','Favorites');
a.innerHTML=`<span class='svg-wrapper'>${svg()}</span><div class='cart-count-bubble mbf-count' hidden><span aria-hidden='true'></span></div>`;
icons.insertBefore(a,icons.querySelector('#cart-icon-bubble'));
a.addEventListener('click',onHeaderClick);
updateHeader();
measureHeader();
}
function arrival(){
var f=null;
try{f=sessionStorage.getItem('mbfav_nav');sessionStorage.removeItem('mbfav_nav')}catch(x){}
if(f&&onFavPage()&&!reduced)burst('out');
}

function handleOf(w){
var a=w.querySelector(`a[href*='/products/']`);
if(!a)return null;
var p=a.getAttribute('href').split('/products/')[1];
return p?decodeURIComponent(p.split('?')[0].split('#')[0]):null;
}
function syncBtn(b){
var on=has(b.getAttribute('data-handle'));
b.classList.toggle('is-active',on);
b.setAttribute('aria-pressed',on?'true':'false');
b.setAttribute('aria-label',on?'Remove from favorites':'Add to favorites');
var lbl=b.querySelector('.mbf-pf-label');
if(lbl){var c=config();lbl.textContent=on?c.pdpLabelOn:c.pdpLabel}
}
function syncAll(){document.querySelectorAll('.mbf-card-btn,.mbf-pf-btn').forEach(syncBtn);updateHeader()}
function mountCards(){
if(!config().card)return;
document.querySelectorAll('.card-wrapper:not([data-mbf])').forEach(function(w){
w.setAttribute('data-mbf','1');
var inner=w.querySelector('.card__inner'),h=handleOf(w);
if(!inner||!h)return;
var b=document.createElement('button');
b.type='button';b.className='mbf-card-btn';b.setAttribute('data-handle',h);
b.innerHTML=svg();
inner.appendChild(b);
syncBtn(b);
});
}
function sizePdp(){
var b=document.querySelector('.mbf-pf-btn--icon');
var s=b&&b.previousElementSibling;
if(b&&s){var h=s.offsetHeight;if(h>0)b.style.width=h+'px'}
}
function mountPdp(){
var cfg=config();
if(!cfg.pdp||document.querySelector('.mbf-pf-btn'))return;
var m=location.pathname.split('/products/')[1];
if(!m)return;
var h=decodeURIComponent(m.split('/')[0]);
var submit=document.querySelector('product-form .product-form__submit')||document.querySelector('.product-form__submit');
if(!submit||!submit.parentNode)return;
var row=submit.parentNode.classList.contains('mbf-pf-row')?submit.parentNode:null;
if(!row){row=document.createElement('div');row.className='mbf-pf-row';submit.parentNode.insertBefore(row,submit);row.appendChild(submit)}
var cls=(submit.className||'').split(' ').filter(function(c){return c&&c!=='product-form__submit'&&c!=='button--full-width'}).join(' ');
var b=document.createElement('button');
b.type='button';
b.className=cls+' mbf-pf-btn mbf-pf-btn--'+(cfg.pdpStyle==='icon-text'?'text':'icon');
b.setAttribute('data-handle',h);
b.innerHTML=svg()+`<span class='mbf-pf-label'></span>`;
row.appendChild(b);
syncBtn(b);
sizePdp();
}
document.addEventListener('click',function(e){
var b=e.target.closest&&e.target.closest('.mbf-card-btn,.mbf-pf-btn');
if(!b)return;
e.preventDefault();e.stopPropagation();
var added=toggle(b.getAttribute('data-handle'));
pop(b);
if(added){sparkle(b);toast('Added to favorites')}else{toast('Removed from favorites')}
var hd=document.querySelector('.header__icon--fav');if(hd)pop(hd);
},true);

function money(c,fmt){
var v=c/100;
function f(d,t,dc){var s=v.toFixed(d).split('.');s[0]=s[0].replace(/(\d)(?=(\d{3})+$)/g,'$1'+t);return s[0]+(s[1]?dc+s[1]:'')}
return (fmt||'{{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/g,function(m,k){
if(k==='amount_no_decimals')return f(0,',','.');
if(k==='amount_with_comma_separator')return f(2,'.',',');
if(k==='amount_no_decimals_with_comma_separator')return f(0,'.',',');
if(k==='amount_no_decimals_with_space_separator')return f(0,' ',',');
return f(2,',','.');
});
}
function imgUrl(u,w){return u?u+(u.indexOf('?')>-1?'&':'?')+'width='+w:''}
function getProduct(h){
if(cache[h])return cache[h];
cache[h]=fetch(ROOT+'products/'+encodeURIComponent(h)+'.js',{headers:{Accept:'application/json'}}).then(function(r){return r.status===404?{gone:true}:(r.ok?r.json():null)}).catch(function(){return null});
return cache[h];
}
function refreshCart(){
fetch(ROOT+'?sections=cart-icon-bubble').then(function(r){return r.json()}).then(function(s){
var html=s['cart-icon-bubble'];if(!html)return;
var d=new DOMParser().parseFromString(html,'text/html');
var src=d.querySelector('.shopify-section'),el=document.getElementById('cart-icon-bubble');
if(src&&el)el.innerHTML=src.innerHTML;
}).catch(function(){});
}
function addToCart(h,btn){
if(btn.classList.contains('is-loading'))return;
getProduct(h).then(function(p){
if(!p||p.gone)return;
var v=p.variants.filter(function(x){return x.available})[0]||p.variants[0];
btn.classList.add('is-loading');
fetch(ROOT+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:v.id,quantity:1}]})})
.then(function(r){return r.json().then(function(j){if(!r.ok)throw new Error(j.description||j.message||'Could not add to cart');return j})})
.then(function(){
btn.classList.remove('is-loading');btn.classList.add('is-done');btn.querySelector('span').textContent='Added';
toast('Added to cart');refreshCart();
setTimeout(function(){btn.classList.remove('is-done');btn.querySelector('span').textContent='Add to cart'},1800);
}).catch(function(err){btn.classList.remove('is-loading');toast(err.message||'Could not add to cart')});
});
}

function initPage(){
var root=document.getElementById('MBFavPage');
if(!root)return;
var grid=document.getElementById('MBFavGrid'),empty=document.getElementById('MBFavEmpty'),sub=document.getElementById('MBFavSub'),clr=document.getElementById('MBFavClear');
var fmt=root.getAttribute('data-money-format');
var token=0;
function setSub(n){sub.textContent=n?(n+(n===1?' item':' items')+' saved'):sub.getAttribute('data-default')}
function showEmpty(){grid.innerHTML='';grid.hidden=true;empty.hidden=false;clr.hidden=true;setSub(0)}
function cardHtml(p,i){
var sale=p.compare_at_price>p.price,multi=p.variants.length>1;
var btn=!p.available?`<button type='button' class='mbf-btn mbf-btn--ghost' disabled><span>Sold out</span></button>`:(multi?`<a class='mbf-btn mbf-btn--primary' href='${esc(p.url)}'><span>Choose options</span></a>`:`<button type='button' class='mbf-btn mbf-btn--primary' data-add><span>Add to cart</span><i class='mbf-spin'></i></button>`);
return `<article class='mbf-card' role='listitem' data-handle='${esc(p.handle)}' style='--i:${i}'><div class='mbf-card__media'><a href='${esc(p.url)}' tabindex='-1' aria-hidden='true'>${p.featured_image?`<img src='${esc(imgUrl(p.featured_image,600))}' alt='${esc(p.title)}' loading='lazy'>`:''}</a>${(sale&&p.available)?`<span class='mbf-badge'>Sale</span>`:''}${!p.available?`<span class='mbf-badge mbf-badge--dark'>Sold out</span>`:''}<button type='button' class='mbf-card__remove' data-remove aria-label='Remove from favorites'>${svg()}</button></div><div class='mbf-card__body'><a class='mbf-card__title' href='${esc(p.url)}'>${esc(p.title)}</a><div class='mbf-card__price'><span class='mbf-now'>${p.price_varies?'From ':''}${esc(money(p.price,fmt))}</span>${sale?`<s>${esc(money(p.compare_at_price,fmt))}</s>`:''}</div><div class='mbf-card__actions'>${btn}</div></div></article>`;
}
function render(){
var list=read(),my=++token;
if(!list.length){showEmpty();return}
empty.hidden=true;grid.hidden=false;clr.hidden=false;setSub(list.length);
grid.innerHTML=list.map(function(){return `<div class='mbf-card mbf-skel-card'><div class='mbf-skel mbf-skel--img'></div><div class='mbf-skel mbf-skel--t'></div><div class='mbf-skel mbf-skel--t short'></div></div>`}).join('');
Promise.all(list.map(getProduct)).then(function(items){
if(my!==token)return;
items.forEach(function(p,i){if(p&&p.gone)remove(list[i])});
var good=items.filter(function(p){return p&&!p.gone});
if(!good.length){showEmpty();return}
setSub(good.length);
grid.innerHTML=good.map(cardHtml).join('');
});
}
grid.addEventListener('click',function(e){
var card=e.target.closest('.mbf-card');if(!card)return;
var h=card.getAttribute('data-handle');
if(e.target.closest('[data-remove]')){
card.classList.add('is-removing');
remove(h);
toast('Removed from favorites');
setTimeout(function(){card.remove();var n=read().length;if(!n)showEmpty();else setSub(n)},380);
return;
}
var add=e.target.closest('[data-add]');
if(add)addToCart(h,add);
});
clr.addEventListener('click',function(){if(window.confirm('Remove all items from favorites?')){clearAll();showEmpty()}});
pageRender=render;
render();
}

window.addEventListener('storage',function(e){if(e.key===KEY){syncAll();if(pageRender)pageRender()}});
var moT,rsT;
function mountAll(){mountHeader();mountCards();mountPdp()}
function observe(){
if(!window.MutationObserver)return;
new MutationObserver(function(){clearTimeout(moT);moT=setTimeout(mountAll,120)}).observe(document.body,{childList:true,subtree:true});
}
function init(){
mountAll();initPage();arrival();observe();
document.addEventListener('mbfav:change',syncAll);
window.addEventListener('resize',function(){clearTimeout(rsT);rsT=setTimeout(function(){measureHeader();sizePdp()},150)});
window.addEventListener('load',function(){measureHeader();sizePdp();syncAll()});
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
document.addEventListener('shopify:section:load',mountAll);
})();
